/** サイト全体で使う定数 */

export const SITE = {
  name: '834CH',
  /** 正規 URL。OGP や canonical で使う */
  url: 'https://834ch.com',
  tagline: 'サカナクション・山口一郎の非公式ネットテレビ',
  description:
    'サカナクションと山口一郎のYouTube動画を、独自の番組表に沿って24時間楽しめる非公式ファンチャンネルです。',
  /** 権利者・関係者からの連絡先 */
  contact: {
    url: 'https://x.com/kondonuts_nf',
    label: '@kondonuts_nf（X）',
  },
} as const

/**
 * 視聴者数を表示しはじめる人数。
 *
 * 数人しかいないときに数字を出すと、かえって寂しく見える。
 * この人数に届くまでは出さない。
 */
export const VIEWER_COUNT_THRESHOLD = 10
